/**
 * Nuri Complete Photography Library
 * Curated Unsplash images for backgrounds, food thumbnails, and motivational moments.
 * All images are free for commercial use (Unsplash/Pexels license).
 */

// ─── DIRECT FOOD NAME MAP (Tier 0 – exact name match) ─────────────
// Maps known food names (from backend suggestions, SIMPLE_FOODS, etc.)
// directly to their image. Checked FIRST before any keyword matching.
const DIRECT_FOOD_NAME_MAP = {
  // === PROTEINS ===
  'protein shake':                     '/food-images/protein_shake.png',
  'protein shake (whey)':              '/food-images/protein_shake.png',
  'grilled chicken breast':            '/food-images/grilled_chicken_breast.png',
  'salmon fillet':                     '/food-images/salmon_fillet.png',
  'salmon fillet (6oz)':               '/food-images/salmon_fillet.png',
  'tuna steak':                        '/food-images/tuna_salad.png',
  'cod fillet':                        '/food-images/cod_fillet.png',
  'shrimp (cooked)':                   '/food-images/shrimp.png',
  'lean ground beef':                  '/food-images/steak.png',
  'pork tenderloin':                   '/food-images/pork_tenderloin.png',
  'turkey breast':                     '/food-images/turkey_breast.png',
  'grilled steak (8oz)':               '/food-images/steak.png',
  // === PLANT PROTEINS ===
  'tofu (firm)':                       '/food-images/tofu_firm.png',
  'tofu':                              '/food-images/tofu_firm.png',
  'tempeh':                            '/food-images/tempeh.png',
  'lentils (cooked)':                  '/food-images/lentils_cooked.png',
  'lentils':                           '/food-images/lentils_cooked.png',
  'chickpeas (cooked)':                '/food-images/chickpeas.png',
  'chickpeas':                         '/food-images/chickpeas.png',
  'black beans (cooked)':              '/food-images/black_beans.png',
  'edamame (1 cup)':                   '/food-images/edamame.png',
  'edamame':                           '/food-images/edamame.png',
  // === EGGS & DAIRY ===
  'scrambled eggs (3)':                '/food-images/scrambled_eggs.png',
  'scrambled eggs (2 eggs)':           '/food-images/scrambled_eggs.png',
  'scrambled eggs':                    '/food-images/scrambled_eggs.png',
  'hard boiled eggs (2)':              '/food-images/hard_boiled_eggs.png',
  'hard boiled eggs':                  '/food-images/hard_boiled_eggs.png',
  'egg white omelette':                '/food-images/scrambled_eggs.png',
  'greek yogurt (plain)':              '/food-images/greek_yogurt_berries.png',
  'greek yogurt (0%)':                 '/food-images/greek_yogurt_berries.png',
  'greek yogurt':                      '/food-images/greek_yogurt_berries.png',
  'cottage cheese (1 cup)':            '/food-images/cottage_cheese.png',
  'cottage cheese':                    '/food-images/cottage_cheese.png',
  // === GRAINS & CARBS ===
  'oatmeal (cooked, 1 cup)':           '/food-images/oatmeal_bowl.png',
  'oatmeal with protein powder':       '/food-images/oatmeal_bowl.png',
  'overnight oats':                    '/food-images/overnight_oats.png',
  'brown rice (1 cup)':                '/food-images/rice_chicken_bowl.png',
  'brown rice + chicken bowl':         '/food-images/rice_chicken_bowl.png',
  'quinoa (cooked, 1 cup)':            '/food-images/quinoa.png',
  'quinoa':                            '/food-images/quinoa.png',
  'sweet potato (medium)':             '/food-images/sweet_potato.png',
  'sweet potato':                      '/food-images/sweet_potato.png',
  'white potato (medium)':             '/food-images/sweet_potato.png',
  'whole wheat pasta (1 cup)':         '/food-images/pasta_sauce.png',
  'pasta with tomato sauce':           '/food-images/pasta_sauce.png',
  // === BOWLS & WRAPS ===
  'burrito bowl (chicken)':            '/food-images/burrito_bowl.png',
  'poke bowl (salmon)':                '/food-images/poke_bowl.png',
  'poke bowl':                         '/food-images/poke_bowl.png',
  'turkey wrap':                       '/food-images/turkey_wrap.png',
  'turkey deli roll-ups (4)':          '/food-images/turkey_wrap.png',
  'turkey deli roll-ups':              '/food-images/turkey_wrap.png',
  'chicken caesar salad':              '/food-images/mixed_salad.png',
  'chicken salad':                     '/food-images/mixed_salad.png',
  'salad with chicken':                '/food-images/mixed_salad.png',
  'grilled chicken salad':             '/food-images/mixed_salad.png',
  'mixed green salad':                 '/food-images/mixed_salad.png',
  'garden salad':                      '/food-images/mixed_salad.png',
  'side salad':                        '/food-images/mixed_salad.png',
  'tuna salad wrap':                   '/food-images/tuna_salad.png',
  'tuna salad':                        '/food-images/tuna_salad.png',
  // === BREAKFAST ===
  'smoothie bowl (acai)':              '/food-images/smoothie_bowl.png',
  'avocado toast (1 slice)':           '/food-images/avocado_toast.png',
  'avocado toast':                     '/food-images/avocado_toast.png',
  'toast':                             '/food-images/whole_wheat_bread.png',
  'toast with butter':                 '/food-images/whole_wheat_bread.png',
  'toast with butter and syrup':       '/food-images/whole_wheat_bread.png',
  'toast with butter syrup':           '/food-images/whole_wheat_bread.png',
  'white toast':                       '/food-images/white_bread.png',
  'wheat toast':                       '/food-images/whole_wheat_bread.png',
  'whole wheat toast':                 '/food-images/whole_wheat_bread.png',
  // === SNACKS ===
  'banana':                            '/food-images/banana.png',
  'banana + peanut butter':            '/food-images/banana.png',
  'apple':                             '/food-images/apple.png',
  'blueberries (1 cup)':               '/food-images/greek_yogurt_berries.png',
  'almonds (1 oz)':                    '/food-images/mixed_nuts.png',
  'walnuts (1 oz)':                    '/food-images/mixed_nuts.png',
  'peanut butter (2 tbsp)':            '/food-images/mixed_nuts.png',
  'mixed nuts (1/4 cup)':              '/food-images/mixed_nuts.png',
  'trail mix (1/4 cup)':               '/food-images/mixed_nuts.png',
  'protein bar':                       '/food-images/protein_bar.png',
  'hummus with veggies':               '/food-images/mixed_salad.png',
  // === VEGGIES & SOUP ===
  'broccoli (steamed, 1 cup)':         '/food-images/steamed_broccoli.png',
  'steamed broccoli + salmon':         '/food-images/salmon_fillet.png',
  'spinach (cooked, 1 cup)':           '/food-images/mixed_salad.png',
  'chicken soup':                      '/food-images/soup_bowl.png',
  // === OTHERS ===
  'avocado (half)':                    '/food-images/avocado_toast.png',
  'steak + asparagus':                 '/food-images/steak.png',

  // === GROCERY ITEMS (raw ingredients, pantry staples) ===
  // Proteins
  'chicken breast':                    '/food-images/grilled_chicken_breast.png',
  'chicken thighs':                    '/food-images/chicken_thighs.png',
  'ground beef':                       '/food-images/ground_beef.png',
  'ground turkey':                     '/food-images/ground_turkey.png',
  'eggs':                              '/food-images/eggs.png',
  'egg whites':                        '/food-images/egg_whites.png',
  'bacon':                             '/food-images/bacon.png',
  'ham':                               '/food-images/ham.png',
  'hot dogs':                          '/food-images/hot_dogs.png',
  'sausage links':                     '/food-images/sausage_links.png',
  'sausage':                           '/food-images/sausage_links.png',
  'turkey sausage':                    '/food-images/sausage_links.png',
  'turkey sausages':                   '/food-images/sausage_links.png',
  'chicken sausage':                   '/food-images/sausage_links.png',
  'deli turkey':                       '/food-images/deli_turkey.png',
  'salami':                            '/food-images/salami.png',
  'pepperoni':                         '/food-images/pepperoni.png',
  'rotisserie chicken':                '/food-images/rotisserie_chicken.png',
  'canned tuna':                       '/food-images/canned_tuna.png',
  'canned chicken':                    '/food-images/canned_chicken.png',
  'sardines':                          '/food-images/sardines.png',
  'lamb chops':                        '/food-images/lamb_chops.png',
  'pork chops':                        '/food-images/pork_chops.png',
  'beef stew meat':                    '/food-images/beef_stew_meat.png',
  'steak':                             '/food-images/steak.png',
  'shrimp':                            '/food-images/shrimp.png',
  'frozen shrimp':                     '/food-images/frozen_shrimp.png',
  'scallops':                          '/food-images/scallops.png',
  'crab':                              '/food-images/crab.png',
  'lobster tail':                      '/food-images/lobster_tail.png',
  'tilapia':                           '/food-images/tilapia.png',
  'tuna steak':                        '/food-images/tuna_steak.png',
  'protein powder':                    '/food-images/protein_powder.png',

  // Dairy
  'greek yogurt':                      '/food-images/greek_yogurt_berries.png',
  'yogurt':                            '/food-images/yogurt.png',
  'whole milk':                        '/food-images/whole_milk.png',
  'milk':                              '/food-images/whole_milk.png',
  'butter':                            '/food-images/butter.png',
  'cheddar cheese':                    '/food-images/cheddar_cheese.png',
  'cheddar':                           '/food-images/cheddar_cheese.png',
  'mozzarella':                        '/food-images/mozzarella.png',
  'parmesan':                          '/food-images/parmesan.png',
  'swiss cheese':                      '/food-images/swiss_cheese.png',
  'feta cheese':                       '/food-images/feta_cheese.png',
  'feta':                              '/food-images/feta_cheese.png',
  'goat cheese':                       '/food-images/goat_cheese.png',
  'cream cheese':                      '/food-images/cream_cheese.png',
  'ricotta':                           '/food-images/ricotta.png',
  'cottage cheese':                    '/food-images/cottage_cheese.png',
  'sour cream':                        '/food-images/sour_cream.png',
  'heavy cream':                       '/food-images/heavy_cream.png',
  'half and half':                     '/food-images/half_and_half.png',
  'whipped cream':                     '/food-images/whipped_cream.png',
  'oat milk':                          '/food-images/oat_milk.png',
  'almond milk':                       '/food-images/almond_milk.png',
  'coconut milk':                      '/food-images/coconut_milk_can.png',
  'ice cream':                         '/food-images/ice_cream.png',

  // Fruits
  'apple':                             '/food-images/apple.png',
  'apples':                            '/food-images/apple.png',
  'banana':                            '/food-images/banana.png',
  'bananas':                           '/food-images/banana.png',
  'orange':                            '/food-images/orange.png',
  'oranges':                           '/food-images/orange.png',
  'grapes':                            '/food-images/grapes.png',
  'strawberries':                      '/food-images/strawberries.png',
  'blueberries':                       '/food-images/blueberries.png',
  'raspberries':                       '/food-images/raspberries.png',
  'cherries':                          '/food-images/cherries.png',
  'mango':                             '/food-images/mango.png',
  'pineapple':                         '/food-images/pineapple.png',
  'watermelon':                        '/food-images/watermelon.png',
  'cantaloupe':                        '/food-images/cantaloupe.png',
  'peach':                             '/food-images/peach.png',
  'peaches':                           '/food-images/peach.png',
  'pear':                              '/food-images/pear.png',
  'pears':                             '/food-images/pear.png',
  'plum':                              '/food-images/plum.png',
  'plums':                             '/food-images/plum.png',
  'kiwi':                              '/food-images/kiwi.png',
  'grapefruit':                        '/food-images/grapefruit.png',
  'lemon':                             '/food-images/lemon.png',
  'lemons':                            '/food-images/lemon.png',
  'lime':                              '/food-images/lime.png',
  'limes':                             '/food-images/lime.png',
  'pomegranate':                       '/food-images/pomegranate.png',
  'coconut':                           '/food-images/coconut.png',
  'frozen berries':                    '/food-images/frozen_berries.png',

  // Vegetables
  'broccoli':                          '/food-images/broccoli.png',
  'spinach':                           '/food-images/spinach.png',
  'kale':                              '/food-images/kale.png',
  'lettuce':                           '/food-images/lettuce.png',
  'carrots':                           '/food-images/carrots.png',
  'celery':                            '/food-images/celery.png',
  'cucumber':                          '/food-images/cucumber.png',
  'tomato':                            '/food-images/tomato.png',
  'tomatoes':                          '/food-images/tomato.png',
  'bell pepper':                       '/food-images/bell_pepper.png',
  'bell peppers':                      '/food-images/bell_pepper.png',
  'onion':                             '/food-images/onion.png',
  'onions':                            '/food-images/onion.png',
  'garlic':                            '/food-images/garlic.png',
  'mushrooms':                         '/food-images/mushrooms.png',
  'zucchini':                          '/food-images/zucchini.png',
  'eggplant':                          '/food-images/eggplant.png',
  'cauliflower':                       '/food-images/cauliflower.png',
  'brussels sprouts':                  '/food-images/brussels_sprouts.png',
  'asparagus':                         '/food-images/asparagus.png',
  'green beans':                       '/food-images/green_beans.png',
  'corn':                              '/food-images/corn.png',
  'sweet potato':                      '/food-images/sweet_potato.png',
  'sweet potatoes':                    '/food-images/sweet_potato.png',
  'beets':                             '/food-images/beets.png',
  'cabbage':                           '/food-images/cabbage.png',
  'bok choy':                          '/food-images/bok_choy.png',
  'radish':                            '/food-images/radish.png',
  'artichoke':                         '/food-images/artichoke.png',
  'jalapeno':                          '/food-images/jalapeno.png',
  'jalapenos':                         '/food-images/jalapeno.png',
  'ginger':                            '/food-images/ginger_root.png',
  'ginger root':                       '/food-images/ginger_root.png',
  'basil':                             '/food-images/basil.png',
  'frozen broccoli':                   '/food-images/frozen_broccoli.png',
  'frozen peas':                       '/food-images/frozen_peas.png',
  'canned tomatoes':                   '/food-images/canned_tomatoes.png',
  'canned corn':                       '/food-images/canned_corn.png',
  'canned black beans':                '/food-images/canned_black_beans.png',

  // Grains & Pasta
  'brown rice':                        '/food-images/brown_rice.png',
  'white rice':                        '/food-images/white_rice.png',
  'rice':                              '/food-images/white_rice.png',
  'oats':                              '/food-images/oats.png',
  'quinoa':                            '/food-images/quinoa.png',
  'couscous':                          '/food-images/couscous.png',
  'spaghetti':                         '/food-images/spaghetti.png',
  'penne pasta':                       '/food-images/penne_pasta.png',
  'pasta':                             '/food-images/penne_pasta.png',
  'macaroni':                          '/food-images/macaroni.png',
  'flour':                             '/food-images/flour.png',
  'cornmeal':                          '/food-images/cornmeal.png',
  'breadcrumbs':                       '/food-images/breadcrumbs.png',
  'bread crumbs':                      '/food-images/breadcrumbs.png',
  'whole wheat bread':                 '/food-images/whole_wheat_bread.png',
  'white bread':                       '/food-images/white_bread.png',
  'bread':                             '/food-images/whole_wheat_bread.png',
  'bagels':                            '/food-images/bagels.png',
  'english muffins':                   '/food-images/english_muffins.png',
  'tortillas':                         '/food-images/tortillas.png',
  'pita bread':                        '/food-images/pita_bread.png',
  'naan':                              '/food-images/naan.png',
  'cereal':                            '/food-images/cereal.png',
  'granola':                           '/food-images/granola.png',
  'rice cakes':                        '/food-images/rice_cakes.png',
  'crackers':                          '/food-images/crackers.png',
  'pretzels':                          '/food-images/pretzels.png',
  'popcorn':                           '/food-images/popcorn.png',
  'tortilla chips':                    '/food-images/tortilla_chips.png',
  'frozen pizza':                      '/food-images/frozen_pizza.png',
  'frozen waffles':                    '/food-images/frozen_waffles.png',

  // Oils, Sauces, Condiments
  'olive oil':                         '/food-images/olive_oil.png',
  'coconut oil':                       '/food-images/coconut_oil.png',
  'vegetable oil':                     '/food-images/vegetable_oil.png',
  'sesame oil':                        '/food-images/sesame_oil.png',
  'soy sauce':                         '/food-images/soy_sauce.png',
  'fish sauce':                        '/food-images/fish_sauce.png',
  'hot sauce':                         '/food-images/hot_sauce.png',
  'sriracha':                          '/food-images/sriracha.png',
  'ketchup':                           '/food-images/ketchup.png',
  'mustard':                           '/food-images/mustard.png',
  'mayonnaise':                        '/food-images/mayonnaise.png',
  'mayo':                              '/food-images/mayonnaise.png',
  'ranch dressing':                    '/food-images/ranch_dressing.png',
  'bbq sauce':                         '/food-images/bbq_sauce.png',
  'marinara sauce':                    '/food-images/marinara_sauce.png',
  'salsa':                             '/food-images/salsa.png',
  'guacamole':                         '/food-images/guacamole.png',
  'hummus':                            '/food-images/hummus.png',
  'tahini':                            '/food-images/tahini.png',
  'vinegar':                           '/food-images/vinegar.png',
  'balsamic vinegar':                  '/food-images/balsamic_vinegar.png',
  'apple cider vinegar':               '/food-images/apple_cider_vinegar.png',
  'worcestershire sauce':              '/food-images/worcestershire.png',
  'worcestershire':                    '/food-images/worcestershire.png',
  'pickles':                           '/food-images/pickles.png',
  'olives':                            '/food-images/olives.png',
  'jam':                               '/food-images/jam.png',
  'jelly':                             '/food-images/jam.png',

  // Nuts, Seeds, Nut Butters
  'almonds':                           '/food-images/almonds.png',
  'cashews':                           '/food-images/cashews.png',
  'walnuts':                           '/food-images/walnuts.png',
  'peanuts':                           '/food-images/peanuts.png',
  'peanut butter':                     '/food-images/peanut_butter.png',
  'almond butter':                     '/food-images/almond_butter.png',
  'trail mix':                         '/food-images/trail_mix.png',
  'mixed nuts':                        '/food-images/mixed_nuts.png',
  'chia seeds':                        '/food-images/chia_seeds.png',
  'flax seeds':                        '/food-images/flax_seeds.png',
  'sunflower seeds':                   '/food-images/sunflower_seeds.png',
  'raisins':                           '/food-images/raisins.png',
  'dried cranberries':                 '/food-images/dried_cranberries.png',
  'dark chocolate':                    '/food-images/dark_chocolate.png',
  'chocolate chips':                   '/food-images/chocolate_chips.png',

  // Baking & Sweeteners
  'sugar':                             '/food-images/sugar.png',
  'brown sugar':                       '/food-images/brown_sugar.png',
  'powdered sugar':                    '/food-images/powdered_sugar.png',
  'honey':                             '/food-images/honey.png',
  'maple syrup':                       '/food-images/maple_syrup.png',
  'vanilla extract':                   '/food-images/vanilla_extract.png',
  'baking powder':                     '/food-images/baking_powder.png',
  'baking soda':                       '/food-images/baking_soda.png',
  'salt':                              '/food-images/salt.png',
  'black pepper':                      '/food-images/black_pepper.png',
  'pepper':                            '/food-images/black_pepper.png',

  // Spices & Herbs
  'cinnamon':                          '/food-images/cinnamon.png',
  'cumin':                             '/food-images/cumin.png',
  'paprika':                           '/food-images/paprika.png',
  'chili powder':                      '/food-images/chili_powder.png',
  'garlic powder':                     '/food-images/garlic_powder.png',
  'onion powder':                      '/food-images/onion_powder.png',
  'oregano':                           '/food-images/oregano.png',
  'italian seasoning':                 '/food-images/italian_seasoning.png',
  'cayenne pepper':                    '/food-images/cayenne_pepper.png',
  'turmeric':                          '/food-images/turmeric.png',
  'rosemary':                          '/food-images/rosemary.png',
  'thyme':                             '/food-images/thyme.png',

  // Beverages
  'coffee':                            '/food-images/black_coffee.png',
  'black coffee':                      '/food-images/black_coffee.png',
  'drip coffee':                       '/food-images/black_coffee.png',
  'coffee beans':                      '/food-images/coffee_beans.png',
  'latte':                             '/food-images/latte.png',
  'cafe latte':                        '/food-images/latte.png',
  'vanilla latte':                     '/food-images/latte.png',
  'caramel latte':                     '/food-images/latte.png',
  'oat milk latte':                    '/food-images/latte.png',
  'almond milk latte':                 '/food-images/latte.png',
  'cappuccino':                        '/food-images/cappuccino.png',
  'espresso':                          '/food-images/espresso.png',
  'double espresso':                   '/food-images/espresso.png',
  'espresso shot':                     '/food-images/espresso.png',
  'americano':                         '/food-images/black_coffee.png',
  'iced coffee':                       '/food-images/iced_coffee.png',
  'iced latte':                        '/food-images/iced_coffee.png',
  'cold brew':                         '/food-images/iced_coffee.png',
  'cold brew coffee':                  '/food-images/iced_coffee.png',
  'iced americano':                    '/food-images/iced_coffee.png',
  'frappuccino':                       '/food-images/iced_coffee.png',
  'matcha':                            '/food-images/matcha_latte.png',
  'matcha latte':                      '/food-images/matcha_latte.png',
  'matcha tea':                        '/food-images/matcha_latte.png',
  'iced matcha':                       '/food-images/matcha_latte.png',
  'chai':                              '/food-images/chai_latte.png',
  'chai latte':                        '/food-images/chai_latte.png',
  'chai tea':                          '/food-images/chai_latte.png',
  'spiced chai':                       '/food-images/chai_latte.png',
  'mocha':                             '/food-images/mocha.png',
  'cafe mocha':                        '/food-images/mocha.png',
  'mocha latte':                       '/food-images/mocha.png',
  'hot chocolate':                     '/food-images/mocha.png',
  'hot cocoa':                         '/food-images/mocha.png',
  'green tea':                         '/food-images/green_tea.png',
  'tea':                               '/food-images/green_tea.png',
  'herbal tea':                        '/food-images/green_tea.png',
  'black tea':                         '/food-images/green_tea.png',
  'earl grey':                         '/food-images/green_tea.png',
  'chamomile tea':                     '/food-images/green_tea.png',
  'peppermint tea':                    '/food-images/green_tea.png',
  'orange juice':                      '/food-images/orange_juice.png',
  'fresh orange juice':                '/food-images/orange_juice.png',
  'apple juice':                       '/food-images/apple_juice.png',
  'cranberry juice':                   '/food-images/cranberry_juice.png',
  'grape juice':                       '/food-images/grape_juice.png',
  'pineapple juice':                   '/food-images/pineapple_juice.png',
  'carrot juice':                      '/food-images/carrot_juice.png',
  'watermelon juice':                  '/food-images/watermelon_juice.png',
  'beet juice':                        '/food-images/beet_juice.png',
  'beetroot juice':                    '/food-images/beet_juice.png',
  'celery juice':                      '/food-images/celery_juice.png',
  'pomegranate juice':                 '/food-images/pomegranate_juice.png',
  'lemonade':                          '/food-images/lemonade.png',
  'fresh lemonade':                    '/food-images/lemonade.png',
  'sparkling water':                   '/food-images/sparkling_water.png',
  'kombucha':                          '/food-images/kombucha.png',
  // Beverage menu items (exact name matches for BeveragePage)
  'coffee with cream':                 '/food-images/latte.png',
  'coffee with cream + sugar':         '/food-images/latte.png',
  'iced coffee with milk':             '/food-images/iced_coffee.png',
  'tea with honey':                    '/food-images/green_tea.png',
  'green juice':                       '/food-images/green_juice.png',
  'store-bought smoothie':             '/food-images/strawberry_smoothie.png',
  'strawberry smoothie':               '/food-images/strawberry_smoothie.png',
  'mango smoothie':                    '/food-images/mango_smoothie.png',
  'berry smoothie':                    '/food-images/berry_smoothie.png',
  'mixed berry smoothie':              '/food-images/berry_smoothie.png',
  'green smoothie':                    '/food-images/green_smoothie.png',
  'tropical smoothie':                 '/food-images/tropical_smoothie.png',
  'banana smoothie':                   '/food-images/banana_smoothie.png',
  'protein smoothie':                  '/food-images/protein_smoothie.png',
  'chocolate protein smoothie':        '/food-images/protein_smoothie.png',
  // Beer
  'light beer':                        '/food-images/light_beer.png',
  'regular beer':                      '/food-images/light_beer.png',
  'craft/ipa':                         '/food-images/craft_beer.png',
  'stout/porter':                      '/food-images/craft_beer.png',
  'hard seltzer':                      '/food-images/hard_seltzer.png',
  'non-alcoholic beer':                '/food-images/light_beer.png',
  'beer':                              '/food-images/light_beer.png',
  // Wine
  'red wine':                          '/food-images/red_wine.png',
  'white wine':                        '/food-images/white_wine.png',
  'rosé':                              '/food-images/white_wine.png',
  'rose':                              '/food-images/white_wine.png',
  'champagne/sparkling':               '/food-images/white_wine.png',
  'champagne':                         '/food-images/white_wine.png',
  'sweet/dessert wine':                '/food-images/red_wine.png',
  'wine':                              '/food-images/red_wine.png',
  // Cocktails
  'shot of liquor':                    '/food-images/cocktail.png',
  'margarita':                         '/food-images/margarita.png',
  'mojito':                            '/food-images/mojito.png',
  'old fashioned':                     '/food-images/old_fashioned.png',
  'gin & tonic':                       '/food-images/gin_and_tonic.png',
  'gin and tonic':                     '/food-images/gin_and_tonic.png',
  'vodka soda':                        '/food-images/vodka_soda.png',
  'cosmopolitan':                      '/food-images/cosmopolitan.png',
  'cosmo':                             '/food-images/cosmopolitan.png',
  'piña colada':                       '/food-images/pina_colada.png',
  'pina colada':                       '/food-images/pina_colada.png',
  'long island iced tea':              '/food-images/long_island_iced_tea.png',
  'long island':                       '/food-images/long_island_iced_tea.png',
  'cocktail':                          '/food-images/cocktail.png',
  // Soda & Energy
  'regular soda':                      '/food-images/soda.png',
  'diet soda':                         '/food-images/soda.png',
  'soda':                              '/food-images/soda.png',
  'energy drink (red bull)':           '/food-images/energy_drink.png',
  'energy drink':                      '/food-images/energy_drink.png',
  'sugar-free energy drink':           '/food-images/energy_drink.png',
  'sports drink (gatorade)':           '/food-images/sports_drink.png',
  'sports drink':                      '/food-images/sports_drink.png',
  'gatorade':                          '/food-images/sports_drink.png',
  // Protein & Milk
  'whey protein + water':              '/food-images/protein_shake.png',
  'whey protein + milk':               '/food-images/protein_shake.png',
  'whey protein':                      '/food-images/protein_shake.png',
  'whole milk':                        '/food-images/whole_milk.png',
  '2% milk':                           '/food-images/whole_milk.png',
  'skim milk':                         '/food-images/whole_milk.png',
  'oat milk':                          '/food-images/oat_milk.png',
  'almond milk':                       '/food-images/almond_milk.png',
  'chocolate milk':                    '/food-images/chocolate_milk.png',
  'coconut milk':                      '/food-images/coconut_milk_can.png',
  'soy milk':                          '/food-images/oat_milk.png',

  // Legumes
  'kidney beans':                      '/food-images/kidney_beans.png',
  'black beans':                       '/food-images/black_beans.png',
  'chickpeas':                         '/food-images/chickpeas.png',
  'lentils':                           '/food-images/lentils_cooked.png',
  'edamame':                           '/food-images/edamame.png',
  'tofu':                              '/food-images/tofu_firm.png',
  'tempeh':                            '/food-images/tempeh.png',

  // Misc
  'tomato paste':                      '/food-images/tomato_paste.png',

  // === COMMON GROCERY ITEMS (added for accurate thumbnails) ===
  'cherry tomatoes':                   '/food-images/tomato.png',
  'cherry tomato':                     '/food-images/tomato.png',
  'grape tomatoes':                    '/food-images/tomato.png',
  'roma tomatoes':                     '/food-images/tomato.png',
  'roma tomato':                       '/food-images/tomato.png',
  'plum tomatoes':                     '/food-images/tomato.png',
  'diced tomatoes':                    '/food-images/canned_tomatoes.png',
  'crushed tomatoes':                  '/food-images/canned_tomatoes.png',
  'sun-dried tomatoes':                '/food-images/tomato.png',
  'sun dried tomatoes':                '/food-images/tomato.png',
  'fresh tomatoes':                    '/food-images/tomato.png',
  'russet potato':                     '/food-images/potatoes.png',
  'yukon gold potatoes':               '/food-images/potatoes.png',
  'red potatoes':                      '/food-images/potatoes.png',
  'fingerling potatoes':               '/food-images/potatoes.png',
  'baby spinach':                      '/food-images/spinach.png',
  'fresh spinach':                     '/food-images/spinach.png',
  'mixed greens':                      '/food-images/lettuce.png',
  'spring mix':                        '/food-images/lettuce.png',
  'romaine':                           '/food-images/lettuce.png',
  'romaine lettuce':                   '/food-images/lettuce.png',
  'iceberg lettuce':                   '/food-images/lettuce.png',
  'red onion':                         '/food-images/onion.png',
  'red onions':                        '/food-images/onion.png',
  'yellow onion':                      '/food-images/onion.png',
  'white onion':                       '/food-images/onion.png',
  'shallot':                           '/food-images/onion.png',
  'shallots':                          '/food-images/onion.png',
  'fresh garlic':                      '/food-images/garlic.png',
  'garlic cloves':                     '/food-images/garlic.png',
  'minced garlic':                     '/food-images/garlic.png',
  'button mushrooms':                  '/food-images/mushrooms.png',
  'cremini mushrooms':                 '/food-images/mushrooms.png',
  'portobello mushrooms':              '/food-images/mushrooms.png',
  'shiitake mushrooms':                '/food-images/mushrooms.png',
  'fresh herbs':                       '/food-images/basil.png',
  'fresh basil':                       '/food-images/basil.png',
  'fresh mint':                        '/food-images/basil.png',
  'fresh thyme':                       '/food-images/thyme.png',
  'fresh rosemary':                    '/food-images/rosemary.png',
  'fresh dill':                        '/food-images/basil.png',

  // === NEWLY GENERATED IMAGES ===
  // Water & Ice
  'water':                             '/food-images/water_bottle.png',
  'water bottle':                      '/food-images/water_bottle.png',
  'bottled water':                     '/food-images/water_bottle.png',
  'drinking water':                    '/food-images/water_bottle.png',
  'ice':                               '/food-images/ice.png',
  'ice cubes':                         '/food-images/ice.png',
  'bag of ice':                        '/food-images/ice.png',

  // Fresh Produce (new)
  'baby carrots':                      '/food-images/baby_carrots.png',
  'potatoes':                          '/food-images/potatoes.png',
  'potato':                            '/food-images/potatoes.png',
  'russet potatoes':                   '/food-images/potatoes.png',
  'baking potatoes':                   '/food-images/potatoes.png',
  'green onions':                      '/food-images/green_onions.png',
  'green onion':                       '/food-images/green_onions.png',
  'scallions':                         '/food-images/green_onions.png',
  'cilantro':                          '/food-images/cilantro.png',
  'fresh cilantro':                    '/food-images/cilantro.png',
  'parsley':                           '/food-images/parsley.png',
  'fresh parsley':                     '/food-images/parsley.png',
  'avocado':                           '/food-images/avocado.png',
  'avocados':                          '/food-images/avocado.png',

  // Broths
  'chicken broth':                     '/food-images/chicken_broth.png',
  'chicken stock':                     '/food-images/chicken_broth.png',
  'beef broth':                        '/food-images/beef_broth.png',
  'beef stock':                        '/food-images/beef_broth.png',
  'broth':                             '/food-images/chicken_broth.png',
  'stock':                             '/food-images/chicken_broth.png',
  'vegetable broth':                   '/food-images/chicken_broth.png',

  // Sauces & Condiments (new)
  'pesto':                             '/food-images/pesto.png',
  'basil pesto':                       '/food-images/pesto.png',
  'dijon mustard':                     '/food-images/dijon_mustard.png',
  'dijon':                             '/food-images/dijon_mustard.png',
  'teriyaki sauce':                    '/food-images/teriyaki_sauce.png',
  'teriyaki':                          '/food-images/teriyaki_sauce.png',
  'hoisin sauce':                      '/food-images/hoisin_sauce.png',
  'hoisin':                            '/food-images/hoisin_sauce.png',

  // Seasonings (new)
  'taco seasoning':                    '/food-images/taco_seasoning.png',
  'smoked paprika':                    '/food-images/smoked_paprika.png',
  'red pepper flakes':                 '/food-images/red_pepper_flakes.png',
  'crushed red pepper':                '/food-images/red_pepper_flakes.png',

  // Proteins (new)
  'whey protein':                      '/food-images/whey_protein.png',
  'whey protein powder':               '/food-images/whey_protein.png',
  'protein powder':                    '/food-images/whey_protein.png',
  'ground pork':                       '/food-images/ground_pork.png',
  'chicken wings':                     '/food-images/chicken_wings.png',
  'wings':                             '/food-images/chicken_wings.png',
  'smoked salmon':                     '/food-images/smoked_salmon.png',
  'lox':                               '/food-images/smoked_salmon.png',

  // Specialty (new)
  'coconut cream':                     '/food-images/coconut_cream.png',
  'frozen vegetables':                 '/food-images/frozen_vegetables.png',
  'frozen veggies':                    '/food-images/frozen_vegetables.png',
  'mixed vegetables':                  '/food-images/frozen_vegetables.png',
};

// ─── SPECIFIC FOOD THUMBNAILS (Tier 1 – exact food match) ─────────
// These take priority over the broad category thumbnails below.
const SPECIFIC_FOOD_THUMBNAILS = {
  protein_shake:     { url: '/food-images/protein_shake.png', alt: 'Protein shake glass' },
  chicken_breast:    { url: '/food-images/grilled_chicken_breast.png', alt: 'Grilled chicken breast' },
  salmon_fillet:     { url: '/food-images/salmon_fillet.png', alt: 'Salmon fillet with lemon' },
  scrambled_eggs:    { url: '/food-images/scrambled_eggs.png', alt: 'Scrambled eggs plate' },
  greek_yogurt:      { url: '/food-images/greek_yogurt_berries.png', alt: 'Greek yogurt with berries' },
  overnight_oats:    { url: '/food-images/overnight_oats.png', alt: 'Overnight oats bowl' },
  banana:            { url: '/food-images/banana.png', alt: 'Fresh banana' },
  chicken_rice_bowl: { url: '/food-images/rice_chicken_bowl.png', alt: 'Chicken rice bowl' },
  turkey_wrap:       { url: '/food-images/turkey_wrap.png', alt: 'Turkey wrap sliced' },
  grilled_steak:     { url: '/food-images/steak.png', alt: 'Grilled steak plate' },
  steamed_broccoli:  { url: '/food-images/steamed_broccoli.png', alt: 'Steamed broccoli' },
  sweet_potato:      { url: '/food-images/sweet_potato.png', alt: 'Baked sweet potato' },
  avocado_toast:     { url: '/food-images/avocado_toast.png', alt: 'Avocado toast' },
  oatmeal_bowl:      { url: '/food-images/oatmeal_bowl.png', alt: 'Oatmeal bowl with toppings' },
  apple:             { url: '/food-images/apple.png', alt: 'Fresh apple' },
  mixed_nuts:        { url: '/food-images/mixed_nuts.png', alt: 'Mixed nuts bowl' },
  cottage_cheese:    { url: '/food-images/cottage_cheese.png', alt: 'Cottage cheese with peach' },
  tuna_salad:        { url: '/food-images/tuna_salad.png', alt: 'Tuna salad plate' },
  hard_boiled_eggs:  { url: '/food-images/hard_boiled_eggs.png', alt: 'Hard boiled eggs' },
  protein_bar:       { url: '/food-images/protein_bar.png', alt: 'Protein bar' },
  chicken_salad:     { url: '/food-images/mixed_salad.png', alt: 'Mixed salad bowl' },
  pasta_sauce:       { url: '/food-images/pasta_sauce.png', alt: 'Pasta with sauce' },
  cooked_shrimp:     { url: '/food-images/shrimp.png', alt: 'Cooked shrimp' },
  soup_bowl:         { url: '/food-images/soup_bowl.png', alt: 'Warm soup bowl' },
  burrito_bowl:      { url: '/food-images/burrito_bowl.png', alt: 'Burrito bowl' },
  tempeh:            { url: '/food-images/tempeh.png', alt: 'Pan-fried tempeh' },
  tofu:              { url: '/food-images/tofu_firm.png', alt: 'Pan-fried tofu cubes' },
  edamame:           { url: '/food-images/edamame.png', alt: 'Steamed edamame pods' },
  lentils:           { url: '/food-images/lentils_cooked.png', alt: 'Cooked lentils bowl' },
  black_beans:       { url: '/food-images/black_beans.png', alt: 'Cooked black beans bowl' },
  chickpeas:         { url: '/food-images/chickpeas.png', alt: 'Roasted chickpeas bowl' },
  quinoa:            { url: '/food-images/quinoa.png', alt: 'Fluffy quinoa bowl' },
  turkey_breast:     { url: '/food-images/turkey_breast.png', alt: 'Roasted turkey breast sliced' },
  cod_fillet:        { url: '/food-images/cod_fillet.png', alt: 'Pan-seared cod fillet' },
  pork_tenderloin:   { url: '/food-images/pork_tenderloin.png', alt: 'Sliced pork tenderloin' },
  poke_bowl:         { url: '/food-images/poke_bowl.png', alt: 'Salmon poke bowl' },
  smoothie_bowl:     { url: '/food-images/smoothie_bowl.png', alt: 'Acai smoothie bowl' },
  black_coffee:      { url: '/food-images/black_coffee.png', alt: 'Black coffee cup' },
  latte:             { url: '/food-images/latte.png', alt: 'Latte with art' },
  cappuccino:        { url: '/food-images/cappuccino.png', alt: 'Cappuccino foam' },
  espresso:          { url: '/food-images/espresso.png', alt: 'Espresso shot' },
  iced_coffee:       { url: '/food-images/iced_coffee.png', alt: 'Iced coffee glass' },
  matcha_latte:      { url: '/food-images/matcha_latte.png', alt: 'Matcha latte green' },
  chai_latte:        { url: '/food-images/chai_latte.png', alt: 'Chai latte spiced' },
  mocha:             { url: '/food-images/mocha.png', alt: 'Mocha with cream' },
};

// Keyword → specific food thumbnail mapping (Tier 1 matching)
// More specific matches checked BEFORE the broad category map.
const SPECIFIC_FOOD_KEYWORD_MAP = {
  protein_shake:     ['protein shake', 'protein smoothie', 'whey shake', 'shake protein', 'smoothie protein'],
  chicken_breast:    ['chicken breast', 'grilled chicken breast', 'baked chicken breast', 'chicken cutlet'],
  salmon_fillet:     ['salmon', 'salmon fillet', 'grilled salmon', 'baked salmon'],
  scrambled_eggs:    ['scrambled eggs', 'scrambled egg', 'scramble'],
  greek_yogurt:      ['greek yogurt', 'yogurt berries', 'yogurt granola', 'yogurt bowl', 'yogurt parfait'],
  overnight_oats:    ['overnight oats', 'overnight oat'],
  banana:            ['banana', 'bananas'],
  chicken_rice_bowl: ['chicken rice', 'chicken and rice', 'chicken & rice', 'rice chicken', 'rice bowl chicken', 'rice + chicken', 'rice prep'],
  turkey_wrap:       ['turkey wrap', 'turkey sandwich', 'turkey club', 'deli turkey', 'turkey deli', 'turkey roll'],
  grilled_steak:     ['steak', 'grilled steak', 'ribeye', 'sirloin', 'ny strip', 'filet mignon', 'strip steak'],
  steamed_broccoli:  ['broccoli', 'steamed broccoli'],
  sweet_potato:      ['sweet potato', 'sweet potatoes', 'yam', 'baked sweet potato'],
  avocado_toast:     ['avocado toast', 'avo toast'],
  oatmeal_bowl:      ['oatmeal', 'oatmeal bowl', 'porridge'],
  apple:             ['apple', 'apples'],
  mixed_nuts:        ['mixed nuts', 'trail mix', 'almonds', 'cashews', 'walnuts', 'pecans'],
  cottage_cheese:    ['cottage cheese'],
  tuna_salad:        ['tuna salad', 'tuna plate', 'tuna can'],
  hard_boiled_eggs:  ['hard boiled egg', 'hard-boiled egg', 'boiled egg', 'hard boiled eggs'],
  protein_bar:       ['protein bar', 'granola bar', 'energy bar', 'kind bar', 'cliff bar', 'rx bar'],
  chicken_salad:     ['chicken salad', 'grilled chicken salad', 'caesar salad chicken'],
  pasta_sauce:       ['pasta with sauce', 'spaghetti bolognese', 'penne', 'fettuccine alfredo', 'pasta dish'],
  cooked_shrimp:     ['shrimp', 'grilled shrimp', 'cooked shrimp', 'prawns', 'garlic shrimp'],
  soup_bowl:         ['soup', 'chicken soup', 'tomato soup', 'minestrone', 'chowder'],
  burrito_bowl:      ['burrito bowl', 'chipotle bowl'],
  tempeh:            ['tempeh'],
  tofu:              ['tofu', 'firm tofu', 'silken tofu'],
  edamame:           ['edamame'],
  lentils:           ['lentil', 'lentils', 'dal', 'daal'],
  black_beans:       ['black bean', 'black beans', 'frijoles negros'],
  chickpeas:         ['chickpea', 'chickpeas', 'garbanzo'],
  turkey_breast:     ['turkey breast', 'roast turkey', 'sliced turkey', 'turkey meat'],
  cod_fillet:        ['cod', 'cod fillet', 'baked cod', 'grilled cod', 'pan-seared cod'],
  pork_tenderloin:   ['pork tenderloin', 'pork loin', 'pork medallion'],
  quinoa:            ['quinoa'],
  poke_bowl:         ['poke bowl', 'poke', 'poké'],
  smoothie_bowl:     ['smoothie bowl', 'acai bowl', 'açaí bowl'],
  black_coffee:      ['black coffee', 'drip coffee', 'americano', 'coffee black', 'filter coffee', 'pour over'],
  latte:             ['latte', 'cafe latte', 'vanilla latte', 'caramel latte', 'oat milk latte', 'almond latte', 'hazelnut latte', 'pumpkin spice latte'],
  cappuccino:        ['cappuccino', 'cappucino', 'dry cappuccino', 'wet cappuccino'],
  espresso:          ['espresso', 'double espresso', 'espresso shot', 'ristretto', 'doppio', 'lungo'],
  iced_coffee:       ['iced coffee', 'iced latte', 'cold brew', 'iced americano', 'frappuccino', 'frappe', 'iced mocha', 'cold coffee'],
  matcha_latte:      ['matcha', 'matcha latte', 'matcha tea', 'iced matcha', 'matcha green tea'],
  chai_latte:        ['chai', 'chai latte', 'chai tea', 'spiced chai', 'dirty chai', 'iced chai'],
  mocha:             ['mocha', 'cafe mocha', 'mocha latte', 'hot chocolate', 'hot cocoa', 'chocolate coffee'],
};

// ─── FOOD CATEGORY THUMBNAILS (Tier 2 – broad category fallback) ──
// Used as fallbacks when no user photo exists.
// Priority: user photo → batch photo → category stock → generic_meal
const FOOD_THUMBNAILS = {
  protein: { url: '/food-images/grilled_chicken_breast.png', alt: 'Grilled chicken plate' },
  salad: { url: '/food-images/mixed_salad.png', alt: 'Fresh green salad bowl' },
  rice: { url: '/food-images/rice_chicken_bowl.png', alt: 'Rice bowl warm' },
  grain: { url: '/food-images/oatmeal_bowl.png', alt: 'Grain bowl' },
  pasta: { url: '/food-images/pasta_sauce.png', alt: 'Pasta with sauce' },
  eggs: { url: '/food-images/scrambled_eggs.png', alt: 'Eggs breakfast plate' },
  sandwich: { url: '/food-images/turkey_wrap.png', alt: 'Sandwich on plate' },
  wrap: { url: '/food-images/turkey_wrap.png', alt: 'Wrap halved' },
  soup: { url: '/food-images/soup_bowl.png', alt: 'Bowl of soup warm' },
  stew: { url: '/food-images/soup_bowl.png', alt: 'Warm stew bowl' },
  fruit: { url: '/food-images/apple.png', alt: 'Fresh fruit' },
  vegetables: { url: '/food-images/steamed_broccoli.png', alt: 'Steamed vegetables' },
  smoothie: { url: '/food-images/strawberry_smoothie.png', alt: 'Smoothie glass' },
  shake: { url: '/food-images/protein_shake.png', alt: 'Protein shake' },
  breakfast: { url: '/food-images/greek_yogurt_berries.png', alt: 'Yogurt granola bowl' },
  yogurt: { url: '/food-images/greek_yogurt_berries.png', alt: 'Yogurt with granola' },
  snack: { url: '/food-images/mixed_nuts.png', alt: 'Almonds in bowl' },
  nuts: { url: '/food-images/mixed_nuts.png', alt: 'Mixed nuts bowl' },
  pizza: { url: 'https://images.pexels.com/photos/6223186/pexels-photo-6223186.jpeg?w=256&h=256&fit=crop&auto=compress', alt: 'Pizza rustic board' },
  seafood: { url: '/food-images/shrimp.png', alt: 'Grilled shrimp plate' },
  fish: { url: '/food-images/salmon_fillet.png', alt: 'Salmon fillet' },
  bowl: { url: '/food-images/burrito_bowl.png', alt: 'Burrito bowl colorful' },
  poke: { url: '/food-images/burrito_bowl.png', alt: 'Poke bowl' },
  coffee: { url: '/food-images/black_coffee.png', alt: 'Black coffee cup' },
  latte: { url: '/food-images/latte.png', alt: 'Latte with art' },
  cappuccino: { url: '/food-images/cappuccino.png', alt: 'Cappuccino foam' },
  espresso: { url: '/food-images/espresso.png', alt: 'Espresso shot' },
  iced_coffee: { url: '/food-images/iced_coffee.png', alt: 'Iced coffee glass' },
  matcha: { url: '/food-images/matcha_latte.png', alt: 'Matcha latte' },
  chai: { url: '/food-images/chai_latte.png', alt: 'Chai latte spiced' },
  mocha: { url: '/food-images/mocha.png', alt: 'Mocha with cream' },
  tea: { url: '/food-images/green_tea.png', alt: 'Green tea cup' },
  beverage: { url: '/food-images/black_coffee.png', alt: 'Coffee cup' },
  bread: { url: '/food-images/whole_wheat_bread.png', alt: 'Toast and bread' },
  toast: { url: '/food-images/whole_wheat_bread.png', alt: 'Toast' },
  dairy: { url: '/food-images/cottage_cheese.png', alt: 'Cottage cheese' },
  milk: { url: '/food-images/whole_milk.png', alt: 'Glass of milk' },
  chocolate_milk: { url: '/food-images/chocolate_milk.png', alt: 'Chocolate milk' },
  juice: { url: '/food-images/orange_juice.png', alt: 'Fresh juice' },
  cocktail: { url: '/food-images/cocktail.png', alt: 'Mixed cocktail' },
  cheese: { url: '/food-images/cottage_cheese.png', alt: 'Cheese' },
  dessert: { url: '/food-images/banana.png', alt: 'Fruit dessert' },
  generic_meal: { url: '/food-images/elegant_dinner.png', alt: 'Beautiful plated meal' },
};

// Keyword → category mapping for matching food names to thumbnails
const FOOD_KEYWORD_MAP = {
  protein: ['chicken', 'steak', 'beef', 'pork', 'turkey', 'protein', 'meat', 'grilled', 'brisket', 'tenderloin', 'filet', 'chop'],
  salad: ['salad', 'greens', 'lettuce', 'kale', 'arugula', 'caesar', 'coleslaw', 'slaw'],
  rice: ['rice', 'fried rice', 'pilaf', 'risotto', 'biryani'],
  grain: ['quinoa', 'oatmeal', 'oats', 'barley', 'couscous', 'granola', 'cereal'],
  pasta: ['pasta', 'spaghetti', 'penne', 'linguine', 'fettuccine', 'mac', 'noodle', 'ramen', 'lasagna'],
  eggs: ['egg', 'omelette', 'scrambled', 'fried egg', 'boiled egg', 'frittata'],
  sandwich: ['sandwich', 'sub', 'burger', 'hamburger', 'panini', 'blt'],
  wrap: ['wrap', 'burrito', 'taco', 'quesadilla', 'enchilada', 'falafel wrap'],
  soup: ['soup', 'broth', 'chili', 'chowder', 'bisque', 'gazpacho'],
  stew: ['stew', 'curry', 'goulash', 'tagine', 'dal'],
  fruit: ['fruit', 'apple', 'banana', 'berries', 'strawberry', 'blueberry', 'mango', 'pineapple', 'orange', 'grape', 'melon', 'watermelon'],
  vegetables: ['broccoli', 'asparagus', 'green beans', 'carrots', 'roasted veget', 'steamed veget', 'spinach', 'tomato', 'tomatoes', 'cucumber', 'celery', 'zucchini', 'cauliflower', 'mushroom', 'eggplant', 'artichoke', 'radish', 'beet', 'turnip', 'parsnip', 'squash', 'brussels', 'cabbage', 'bok choy', 'pepper', 'onion', 'garlic', 'corn', 'pea', 'potato', 'sweet potato', 'kale', 'lettuce'],
  smoothie: ['smoothie', 'shake', 'protein shake', 'protein smoothie', 'berry smoothie', 'green smoothie', 'tropical smoothie', 'banana smoothie', 'mango smoothie', 'strawberry smoothie'],
  juice: ['juice', 'lemonade', 'cranberry', 'pomegranate juice', 'beet juice', 'celery juice', 'watermelon juice', 'carrot juice', 'pineapple juice', 'grape juice'],
  cocktail: ['cocktail', 'margarita', 'mojito', 'old fashioned', 'cosmopolitan', 'piña colada', 'pina colada', 'long island', 'daiquiri', 'martini', 'manhattan'],
  breakfast: ['pancake', 'waffle', 'french toast', 'granola', 'yogurt', 'acai', 'porridge'],
  yogurt: ['yogurt', 'cottage cheese', 'parfait'],
  snack: ['bar', 'crackers', 'chips', 'popcorn', 'trail mix', 'edamame', 'hummus'],
  nuts: ['nuts', 'almonds', 'cashews', 'walnuts', 'pecans', 'peanut', 'pistachio'],
  pizza: ['pizza', 'flatbread', 'naan', 'calzone'],
  seafood: ['shrimp', 'prawn', 'lobster', 'crab', 'calamari', 'clam', 'mussel', 'oyster'],
  fish: ['salmon', 'tuna', 'cod', 'tilapia', 'halibut', 'trout', 'sushi', 'sashimi', 'fish'],
  bowl: ['poke', 'buddha bowl', 'power bowl', 'acai bowl', 'grain bowl'],
  coffee: ['coffee', 'espresso', 'latte', 'cappuccino', 'americano', 'mocha', 'cold brew', 'frappuccino', 'macchiato', 'cortado'],
  tea: ['tea', 'matcha', 'chai', 'herbal tea', 'green tea', 'black tea', 'earl grey', 'chamomile', 'peppermint tea', 'oolong'],
  bread: ['bread', 'toast', 'bagel', 'muffin', 'croissant', 'biscuit', 'roll'],
  dairy: ['milk', 'cream', 'butter', 'whey', 'chocolate milk'],
  dessert: ['cake', 'cookie', 'brownie', 'ice cream', 'pie', 'donut', 'pastry', 'cupcake', 'chocolate'],
};

// ─── TIME-OF-DAY BACKGROUNDS ─────────────────────────────────────
// Each screen gets a time-aware variant. Falls back to default if no time variant.
const TIME_OF_DAY_BACKGROUNDS = {
  morning: { // 6am - 11am
    url: 'https://static.prod-images.emergentagent.com/jobs/f25cb12d-d66a-4bae-856a-667f8d183d87/images/9d3242bb85ebabdbce23b1caeee72e1d1f66b608646ea732fce5a807616bb361.png',
    alt: 'Bright kitchen counter with morning sunlight, fresh herbs in clay pots, cutting board, bowl of lemons on marble',
    blur: 6,
    overlay: 'rgba(255,255,255,0.20)',
  },
  afternoon: { // 12pm - 4pm
    url: 'https://static.prod-images.emergentagent.com/jobs/f25cb12d-d66a-4bae-856a-667f8d183d87/images/47b4a9d827e2b5d5b86ee20098bb4aba827b2374a33778cadc5ded2e55be53a6.png',
    alt: 'Bright kitchen with garden view, fresh vegetables and herbs on white counter, natural daylight',
    blur: 8,
    overlay: 'rgba(255,255,255,0.20)',
  },
  evening: { // 5pm - 8pm
    url: 'https://static.prod-images.emergentagent.com/jobs/f25cb12d-d66a-4bae-856a-667f8d183d87/images/e7a011b853f175b73088d6afa2399c87c4e020988059b6033faadde0cc600b60.png',
    alt: 'Candlelit dinner table with wine glasses, ceramic plates on wood table, warm golden-hour atmosphere',
    blur: 8,
    overlay: 'rgba(40,30,15,0.20)',
  },
  night: { // 9pm - 5am
    url: 'https://static.prod-images.emergentagent.com/jobs/f25cb12d-d66a-4bae-856a-667f8d183d87/images/787439d2f6b73048777c3f88a6e1554500ddb1f012bc7865dd80c10691368c78.png',
    alt: 'Quiet modern kitchen at night with warm pendant light, deep teal and dark sage tones',
    blur: 10,
    overlay: 'rgba(15,25,18,0.20)',
  },
};

const SPECIAL_BACKGROUNDS = {
  forest: {
    url: 'https://static.prod-images.emergentagent.com/jobs/f25cb12d-d66a-4bae-856a-667f8d183d87/images/dd5ab627642f58495f08f29049bb8fb8b4b6964d8b1c8b6fd4f237639981ee96.png',
    alt: 'Peaceful forest clearing with dappled golden sunlight through green canopy, lush ferns and moss',
    blur: 10,
    overlay: 'rgba(15,25,15,0.18)',
  },
  capture: {
    url: 'https://static.prod-images.emergentagent.com/jobs/f25cb12d-d66a-4bae-856a-667f8d183d87/images/9b0f6d85413bb8cd52f1e8d298db28f3708befc70fe7034edbdeb0e575cf1ab7.png',
    alt: 'Overhead food preparation scene with herbs, olive oil, avocado and lemons on marble counter',
    blur: 8,
    overlay: 'rgba(0,0,0,0.20)',
  },
};

// ─── SCREEN BACKGROUNDS ─────────────────────────────────────────
const SCREEN_BACKGROUNDS = {
  dashboard: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/b76463ff717cd71620dd2af4c5393183e6fb0360d2616230a6942a4fbdd3445b.png',
    alt: 'Bright airy kitchen with colorful fruits and morning sunlight',
    blur: 8,
  },
  meal_logging: {
    url: 'https://images.unsplash.com/photo-1633095200795-66958a063c77?w=1920&h=1080&fit=crop&q=75',
    alt: 'Cutting board with vegetables',
  },
  what_to_eat: {
    url: 'https://images.unsplash.com/photo-1764709981888-65e5389f4abc?w=1920&h=1080&fit=crop&q=75',
    alt: 'Tuscan landscape with rolling hills',
  },
  meal_prep: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/a4b01c301b25a432f59981fcb62ac6444f39d05a1602d82bd0c72dded2626b6a.png',
    alt: 'Bright colorful meal prep containers with fresh grilled chicken and vegetables',
    blur: 8,
  },
  glp1: {
    url: 'https://images.unsplash.com/photo-1662106312936-5d8b9cbddb80?w=1920&h=1080&fit=crop&q=75',
    alt: 'Tea cup with plant peaceful morning',
  },
  meal_history: {
    url: 'https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=1920&h=1080&fit=crop&q=75',
    alt: 'Colorful fruits and vegetables spread',
  },
  meal_detail: {
    url: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1920&h=1080&fit=crop&q=75',
    alt: 'Beautifully plated food overhead',
  },
  weekly_summary: {
    url: 'https://images.unsplash.com/photo-1476224203421-9ac39bcb3327?w=1920&h=1080&fit=crop&q=75',
    alt: 'Fresh ingredients artfully arranged',
  },
  onboarding: [
    { url: 'https://images.unsplash.com/photo-1605804326092-f5af8ae26b04?w=1920&h=1080&fit=crop&q=75', alt: 'Mediterranean food table' },
    { url: 'https://images.unsplash.com/photo-1764709981888-65e5389f4abc?w=1920&h=1080&fit=crop&q=75', alt: 'Tuscan hills vineyard' },
    { url: 'https://images.pexels.com/photos/4389948/pexels-photo-4389948.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop', alt: 'Rustic warm kitchen' },
    { url: 'https://images.unsplash.com/photo-1551218372-22e08ee09d3b?w=1920&h=1080&fit=crop&q=75', alt: 'Salmon prep ingredients' },
  ],
  settings: null, // Subtle texture only, no full photo
  // Health mode hubs
  celiac: {
    url: 'https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=1920&h=1080&fit=crop&q=75',
    alt: 'Colorful fresh vegetables and fruits spread on table',
    blur: 8,
  },
  athlete: {
    url: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1920&h=1080&fit=crop&q=75',
    alt: 'Beautifully plated healthy food overhead',
    blur: 8,
  },
  senior: {
    url: 'https://images.unsplash.com/photo-1476224203421-9ac39bcb3327?w=1920&h=1080&fit=crop&q=75',
    alt: 'Fresh ingredients artfully arranged on table',
    blur: 8,
  },
  eds_mcas: {
    url: 'https://images.unsplash.com/photo-1559474520-89441fd583dd?w=1920&h=1080&fit=crop&q=75',
    alt: 'Fresh ingredients on counter with natural light',
    blur: 8,
  },
  family: {
    url: 'https://images.unsplash.com/photo-1605804326092-f5af8ae09d04?w=1920&h=1080&fit=crop&q=75',
    alt: 'Colorful family meal spread on table',
    blur: 8,
  },
  ed_recovery: {
    url: 'https://images.unsplash.com/photo-1662106312936-5d8b9cbddb80?w=1920&h=1080&fit=crop&q=75',
    alt: 'Peaceful tea cup with plant in morning light',
    blur: 10,
  },
  mode_compare: {
    url: 'https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=1920&h=1080&fit=crop&q=75',
    alt: 'Vibrant fruits and vegetables display',
    blur: 8,
  },
  restaurant: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/ea234b57e021af4da3f2fa32dab83698f94186e25eea5bf822ecc0aaebe2daa5.png',
    alt: 'Warm intimate restaurant interior with candlelit tables and Edison bulbs',
    blur: 8,
    overlay: 'rgba(40,25,10,0.18)',
  },
  recipes: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/2b8c68c9820ee74ffec9e0130c6438c49f3d1f584e724d854e492c1149f09480.png',
    alt: 'Fresh cooking ingredients on rustic marble counter with herbs and olive oil',
    blur: 8,
  },
  challenges: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/b02a77854960b600945c1b6a1fa38c143e150acb8a22eb250428efd483fb5012.png',
    alt: 'Golden sunrise running trail through lush green park',
    blur: 8,
    overlay: 'rgba(20,30,10,0.15)',
  },
  voice_journal: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/ed198ca1124e7a6e925048e8b1829a91fb0407e81520770e45ba452225b462a6.png',
    alt: 'Cozy morning scene with journal and steaming tea by window',
    blur: 8,
    overlay: 'rgba(30,25,15,0.15)',
  },
  fasting: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/de8439112d0c5bc3ad41b84c36d88173a7e31a07889b453333b36da387c15bbc.png',
    alt: 'Minimalist zen still life with clean plate and rosemary sprig',
    blur: 10,
    overlay: 'rgba(255,255,255,0.12)',
  },
  accountability: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/7b89a4476ce3645d12f7bf4ac96cd6278230aa7c558551130ffbaefcbfa4b376.png',
    alt: 'Warm social dinner table with colorful healthy plates and string lights',
    blur: 8,
    overlay: 'rgba(35,25,10,0.18)',
  },
  batch_upload: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/1004168b2ba16930c9abe7bcba66c0cf104c6495074819e8e99e62abf300b53b.png',
    alt: 'Colorful meal prep bowls with salmon, quinoa and fresh vegetables overhead',
    blur: 8,
  },
  pregnancy: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/ecb56bf4ace3ad121d3b6e4b99cecf86cd60a051f6d26f43b051c0f409c48672.png',
    alt: 'Soft morning light on ceramic bowl of fresh fruits on kitchen windowsill',
    blur: 10,
    overlay: 'rgba(30,20,10,0.12)',
  },
  progress_photos: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/37ffa158f1fe062cf1522e6f7ab517479fc07a592f5ef49b6b33bc112ac73a79.png',
    alt: 'Bright modern gym interior with natural light and polished wood floor',
    blur: 8,
    overlay: 'rgba(255,255,255,0.10)',
  },
  diabetes: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/c1e93be140b656d728305eb9ef46031d92dca8f49bf2edf86fe23b9f1f50c24d.png',
    alt: 'Balanced Mediterranean meal with grilled fish and colorful roasted vegetables',
    blur: 8,
  },
  grocery: {
    url: 'https://static.prod-images.emergentagent.com/jobs/b0cf92b3-8c54-43fb-bbfc-30eca96b9bc1/images/6eb2a4f02dcc60d8ec97978050b89f7bb8e787a7c68df385405a700f59f44a49.png',
    alt: 'Canvas tote bag overflowing with fresh produce and bread on wooden counter',
    blur: 8,
  },
};

// ─── MOTIVATIONAL IMAGES ─────────────────────────────────────────
const MOTIVATIONAL_IMAGES = {
  food: [
    { url: 'https://images.unsplash.com/photo-1569147724124-7fba29b45d01?w=400&h=200&fit=crop&q=80', alt: 'Fresh red grapes' },
    { url: 'https://images.unsplash.com/photo-1764521882411-549ceb0160a7?w=400&h=200&fit=crop&q=80', alt: 'Pears on a plate' },
    { url: 'https://images.unsplash.com/photo-1751756699185-888f29107bfd?w=400&h=200&fit=crop&q=80', alt: 'Strawberries on plate' },
    { url: 'https://images.pexels.com/photos/7627437/pexels-photo-7627437.jpeg?w=400&h=200&fit=crop&auto=compress', alt: 'Gourmet vegetables' },
  ],
  nature: [
    { url: 'https://images.unsplash.com/photo-1676281019373-9c156722a3e3?w=400&h=200&fit=crop&q=80', alt: 'Ocean sunset' },
    { url: 'https://images.unsplash.com/photo-1759931925625-73e3d7edd978?w=400&h=200&fit=crop&q=80', alt: 'Misty sunrise' },
    { url: 'https://images.unsplash.com/photo-1560996025-95b43d543770?w=400&h=200&fit=crop&q=80', alt: 'Foggy lake' },
    { url: 'https://images.pexels.com/photos/36509139/pexels-photo-36509139.jpeg?w=400&h=200&fit=crop&auto=compress', alt: 'Sunrise behind tree' },
    { url: 'https://images.pexels.com/photos/36397724/pexels-photo-36397724.jpeg?w=400&h=200&fit=crop&auto=compress', alt: 'Golden ocean sunrise' },
  ],
  movement: [
    { url: 'https://images.unsplash.com/photo-1758274536083-b821befda77c?w=400&h=200&fit=crop&q=80', alt: 'Yoga in park' },
    { url: 'https://images.unsplash.com/photo-1758274534291-633ab603ec4d?w=400&h=200&fit=crop&q=80', alt: 'Outdoor yoga' },
    { url: 'https://images.pexels.com/photos/6697134/pexels-photo-6697134.jpeg?w=400&h=200&fit=crop&auto=compress', alt: 'Yoga stretch' },
    { url: 'https://images.pexels.com/photos/7592740/pexels-photo-7592740.jpeg?w=400&h=200&fit=crop&auto=compress', alt: 'Morning yoga' },
  ],
};

// ─── HELPER FUNCTIONS ─────────────────────────────────────────

/**
 * Get a food thumbnail based on food name. 2-tier matching:
 *   Tier 1: Specific food match (protein shake, chicken breast, etc.)
 *   Tier 2: Broad category fallback (protein, salad, grain, etc.)
 * Returns { url, alt }
 */
export function getFoodThumbnail(foodName) {
  if (!foodName) return { ...FOOD_THUMBNAILS.generic_meal, isGeneric: true };
  const lower = foodName.toLowerCase();

  // Tier 0 — Direct name match (highest priority, exact food names)
  // Also check without parenthetical suffixes: "Protein Shake" from "Protein Shake (extra)"
  const directMatch = DIRECT_FOOD_NAME_MAP[lower];
  if (directMatch) return { url: directMatch, alt: foodName, isGeneric: false };

  // Try stripping trailing parenthetical info: "Greek Yogurt (0%)" → "greek yogurt"
  const stripped = lower.replace(/\s*\(.*?\)\s*$/, '').trim();
  if (stripped !== lower) {
    const strippedMatch = DIRECT_FOOD_NAME_MAP[stripped];
    if (strippedMatch) return { url: strippedMatch, alt: foodName, isGeneric: false };
  }

  // Also check batch meal names like "Chicken & Rice Prep (4 servings left)"
  // Strip "prep" and servings info
  const batchStripped = lower.replace(/\s*prep\b.*$/i, '').replace(/\s*\(.*?\)\s*$/, '').trim();
  if (batchStripped !== lower && batchStripped !== stripped) {
    const batchMatch = DIRECT_FOOD_NAME_MAP[batchStripped];
    if (batchMatch) return { url: batchMatch, alt: foodName, isGeneric: false };
  }

  // Tier 1 — Specific food match (highest priority)
  for (const [specificKey, keywords] of Object.entries(SPECIFIC_FOOD_KEYWORD_MAP)) {
    for (const keyword of keywords) {
      if (lower.includes(keyword)) {
        const match = SPECIFIC_FOOD_THUMBNAILS[specificKey] || FOOD_THUMBNAILS.generic_meal;
        return { ...match, isGeneric: false };
      }
    }
  }

  // Tier 2 — Broad category fallback
  for (const [category, keywords] of Object.entries(FOOD_KEYWORD_MAP)) {
    for (const keyword of keywords) {
      if (lower.includes(keyword)) {
        const match = FOOD_THUMBNAILS[category] || FOOD_THUMBNAILS.generic_meal;
        return { ...match, isGeneric: false };
      }
    }
  }

  return { ...FOOD_THUMBNAILS.generic_meal, isGeneric: true };
}

/**
 * Get a motivational image based on context.
 */
export function getMotivationalImage(context) {
  const CONTEXT_MAP = {
    daily_win: 'nature',
    welcome_back: 'food',
    streak_milestone: 'nature',
    movement_reminder: 'movement',
  };
  const category = CONTEXT_MAP[context] || 'nature';
  const images = MOTIVATIONAL_IMAGES[category];
  const dayOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0)) / 86400000);
  return images[dayOfYear % images.length];
}

/**
 * Get current time-of-day period.
 */
export function getTimeOfDay() {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 21) return 'evening';
  return 'night';
}

/**
 * Get time-aware background for the current period.
 * Returns { url, alt } for use in ScreenBackground.
 */
export function getTimeBackground() {
  return TIME_OF_DAY_BACKGROUNDS[getTimeOfDay()];
}

/**
 * Get screen background config.
 * Returns { url, alt } for a given screen name.
 * If useTimeOfDay is true, blends the time-aware background with the screen's.
 */
export function getScreenBackground(screenName, useTimeOfDay = false) {
  if (useTimeOfDay) {
    return getTimeBackground();
  }
  const bg = SCREEN_BACKGROUNDS[screenName];
  if (!bg) return null;
  if (Array.isArray(bg)) {
    const dayOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0)) / 86400000);
    return bg[dayOfYear % bg.length];
  }
  return bg;
}

export function getSpecialBackground(name) {
  return SPECIAL_BACKGROUNDS[name] || null;
}

export function isDarkPeriod() {
  const period = getTimeOfDay();
  return period === 'evening' || period === 'night';
}

export { FOOD_THUMBNAILS, SPECIFIC_FOOD_THUMBNAILS, SCREEN_BACKGROUNDS, MOTIVATIONAL_IMAGES, FOOD_KEYWORD_MAP, SPECIFIC_FOOD_KEYWORD_MAP, TIME_OF_DAY_BACKGROUNDS, SPECIAL_BACKGROUNDS };
export default { getFoodThumbnail, getMotivationalImage, getScreenBackground, getTimeOfDay, getTimeBackground, getSpecialBackground, isDarkPeriod };
